<template>
    <div>
        <div class="modal-header">Lista nieprzeczytanych powiadomień</div>
        <div class="modal-body" style="padding-bottom: 0px">
            <transition>
                <div class="no-notifications w-100 text-a-c m-y-5" v-if="notificationsCount === 0">Nie masz nowych powiadomień.</div>
                <div v-else>
                    <transition-group name="list" tag="p">
                        <div class="card m-y-1" v-for="notification in notifications" :key="notification.id"">
                            <div class="card-body">
                                <small class="w-100 text-a-r text-primary" style="margin-top: -10px;">{{notification.date}}</small>
                                <h4 class="m-0 m-b-1">{{notification.title}}</h4>
                                <p class="m-0" v-html="notification.content"></p>
                            </div>
                        </div>
                    </transition-group>
                </div>
            </transition>
        </div>
        <div class="modal-action flex-align-right">
            <button class="button-free-p" @click="goToHistory()">Przejdź do przeczytanych</button>
            <button @click="closeNotification()">Zamknij</button>
        </div>
    </div>
</template>

<script>
  export default {
    data: () => {
      return {}
    },
      methods: {
          goToHistory(){
              this.closeNotification();
              this.$router.push('/notifications');
          },
          closeNotification(){
              if (localStorage.getItem("isOpenedNotifications"))
              {
                  this.hideModal('#notificationsmodal');
                  localStorage.setItem("isOpenedNotifications",false);
                  this.notifications.map((notify) => {
                      this.$store.dispatch('setAsRead',notify.id);
                  });
              }
          },

      },
      mounted: function () {
          $(document).on('click', '.modal-page-show', this.closeNotification);
          $(document).on('click', '.modal-close', this.closeNotification);
      },
      computed: {
          notificationsCount: function () {
              return this.$store.state.notifications.newCount;
          },
          notifications: function () {
              return this.$store.state.notifications.list;
          }
      }
  }
</script>

<style>
    .no-notifications{
        color: #c5c5c5;
    }

    .list-item {
        display: inline-block;
        margin-right: 10px;
    }
    .list-enter-active, .list-leave-active {
        transition: all .3s;
    }
    .list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
        opacity: 0;
        transform: translateY(30px);
    }

</style>